// project import
import Navigation from "./Navigation";
import SimpleBar from "components/third-party/SimpleBar";
import { useLayoutEffect, useState } from "react";
import menuItem from "menu-items";
import { Box, Divider, List } from "@mui/material";
import NavItem from "./Navigation/NavItem";
import DrawerOpenToggle from "./DrawerOpenToggle";
import { V2 } from "../drawerV2Tokens";

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {
  const [menuItems, setMenuItems] = useState({ items: [] });

  useLayoutEffect(() => {
    setMenuItems(menuItem);
  }, []);

  const supportItem = menuItems.items.find((item) => item.id === "Support");

  return (
    <>
      <SimpleBar
        sx={{ "& .simplebar-content": { display: "flex", flexDirection: "column" } }}
      >
        <Navigation />
      </SimpleBar>
      <Box sx={{ mt: "auto", mb: 2 }}>
        <List sx={{ py: 0 }}>
          <DrawerOpenToggle />
        </List>
        {supportItem && (
          <>
            <Divider
              sx={{
                my: "10px !important",
                width: "80%",
                margin: "auto",
                borderColor: V2.line,
              }}
            />
            <List sx={{ py: 0 }}>
              <NavItem item={supportItem} level={1} isParents />
            </List>
          </>
        )}
      </Box>
    </>
  );
}
